// extracted by mini-css-extract-plugin
module.exports = {"ParagraphInfoBox__root":"WbIl","ParagraphInfoBox__box":"c9Em","ParagraphInfoBox__inner":"BRGh"};